import {combineReducers} from 'redux'
import profile from './profile'
import lists from './lists'
import data from './data'

export default combineReducers({
    profile,
    lists,
    data
});



// WEBPACK FOOTER //
// ./src/reducers/data/index.js